import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/user-billing")({
    beforeLoad: () => {
        throw redirect({ to: "/users/billing", replace: true });
    },
});
